import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { TextsContext } from "context/textsContext";
import { useMyFavoritePlanForm } from "context/MyFavoritePlanFormContext";
import { MY_FAVORITE_PLAN_STEPS, buildFavPlanPath, findFavPlanStepIndex, getApplicableFavPlanSteps, FAV_PLAN_FIRST_STEP_SLUG } from "constants/myFavoritePlanForm";
import StyleStep from "scss/step.module.scss";

const FavoritePlanSidebarSteps = () => {
    const { texts } = useContext(TextsContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { validateBaseInformation, favoritePlanId, getIncompleteModules, isFemale } = useMyFavoritePlanForm();

    const currentModuleId = MY_FAVORITE_PLAN_STEPS[findFavPlanStepIndex(pathname)]?.id;
    const incompleteModules = getIncompleteModules();
    const pendingText = texts?.menu_options_pending_fields ?? 'This step has pending fields';

    const sidebarModules = MY_FAVORITE_PLAN_STEPS.filter((step, idx) =>
        MY_FAVORITE_PLAN_STEPS.findIndex(s => s.id === step.id) === idx
    );

    // "Riders" agrupa maternidad/preventive-checkup/eye-surgery bajo un mismo id;
    // si el usuario no es elegible para maternidad, ese sub-step no está en la
    // lista aplicable y hay que entrar por el siguiente (preventive-checkup) en
    // vez de por uno al que no puede acceder.
    const applicableSteps = getApplicableFavPlanSteps(isFemale());

    const handleClick = (moduleId) => {
        if (pathname.endsWith(`/${FAV_PLAN_FIRST_STEP_SLUG}`)) {
            validateBaseInformation();
        }
        const targetStep = applicableSteps.find(step => step.id === moduleId)
            ?? MY_FAVORITE_PLAN_STEPS.find(step => step.id === moduleId);
        navigate(buildFavPlanPath(targetStep.slug, favoritePlanId));
    };

    return (
        <ul className={StyleStep.StyleStep}>
            {sidebarModules.map((step) => {
                const isPast = currentModuleId > step.id;
                const isActive = currentModuleId === step.id;
                // Sólo se marca un módulo anterior al que se está viendo: mientras el
                // usuario esté parado en el paso, no se le muestra la X.
                const isPending = isPast && incompleteModules.includes(step.id);
                return (
                    <li
                        key={step.id}
                        title={isPending ? pendingText : undefined}
                        className={`${StyleStep.step} ${isPast ? StyleStep.stepPastVisited : ''} ${isActive ? StyleStep.stepVisited : ''} ${!isPast && !isActive ? StyleStep.stepNoVisited : ''} ${isPending ? StyleStep.stepPending : ''}`}
                    >
                        <span className={StyleStep.dot}>
                            <Icon icon={isPending ? "mdi:close-thick" : "mdi:check-bold"} className={StyleStep.icon} />
                        </span>
                        <span onClick={() => handleClick(step.id)} className={StyleStep.texto}>{texts?.[step.labelKey] ?? step.label}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default FavoritePlanSidebarSteps;
